import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsContainer = (props: Props) => {
  const { children } = props;

  const { match } = useResponsive();

  const containerResponsiveStyles = match([
    undefined,
    styles.containerSM,
    styles.containerSM,
    styles.containerLG,
  ]);

  const containerStyles = [styles.container, containerResponsiveStyles];

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  containerSM: {
    minHeight: '90%',
  },
  containerLG: {
    minHeight: 900,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
